import moment from 'moment';

export default class ArticleCommentModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.comment = data.comment || '';
    this.created = moment(data.created).toDate();
  }
}
